import { call, select } from 'redux-saga/effects';

import * as Constants from '../../constants';
import * as D from '../../deps';
import * as Utils from '../../utils';

export function* onLoginSuccess() {
  const listenerKruxToken = yield select(D.Utils.Listener.getCurrentListenerKruxTokenFromState);
  yield call(Utils.setIdentity, listenerKruxToken);
}

export function* onLogoutSuccess() {
  yield call(Utils.logout);
}

export function* onRegisterSuccess() {
  yield call(Utils.logEvent, Constants.BranchioEvents.COMPLETE_REGISTRATION);
}

export function* onAcquireOfferSuccess({ payload: { specialOfferToken } }) {
  const hasUserDowngraded = yield select(D.Selectors.Payments.hasUserDowngraded);
  // We don't send SUBSCRIBE event to Branch.io, if it's an downgrade
  if (hasUserDowngraded) {
    return;
  }

  const isTrial = yield select(D.Selectors.Payments.getInPaymentBackedTrial);
  const customerEventAlias = isTrial
    ? Constants.CustomerEventAliasValues.TRIAL
    : Constants.CustomerEventAliasValues.SUBSCRIBE;
  const customData = {
    isTrial,
    productType: yield select(D.Selectors.Payments.getActiveProductType), // TRIAL_SUBSCRIPTION, CONSUMER_GIFT, etc.
    tier: yield select(D.Selectors.Payments.getActiveProductGroupTier),
    campaignId: yield select(D.Selectors.Payments.getSpecialOfferCampaignId),
    promoCode: specialOfferToken,

    // Trial Product
    trialDurationType: isTrial
      ? yield select(D.Selectors.Payments.getActiveProductDurationType)
      : '',
    trialDurationTime: isTrial
      ? yield select(D.Selectors.Payments.getActiveProductDurationTime)
      : '',
    trialTimesRenewable: isTrial
      ? yield select(D.Selectors.Payments.getActiveProductTimesRenewable)
      : '',
    trialPrice: isTrial ? yield select(D.Selectors.Payments.getActiveProductPrice) : '',

    // Subscription Product
    subscriptionDurationType: yield select(D.Selectors.Payments.getSubscriptionDurationType),
    subscriptionDurationTime: yield select(D.Selectors.Payments.getSubscriptionDurationTime),
    subscriptionPrice: yield select(D.Selectors.Payments.getSubscriptionPrice),
  };

  yield call(
    Utils.logEvent,
    Constants.BranchioEvents.SUBSCRIBE,
    customData,
    [],
    customerEventAlias,
  );
}
